export function toggleQuestionOption(selected: string[], option: string): string[] {
  const normalized = option.trim();
  if (!normalized) return selected;
  return selected.includes(normalized) ? selected.filter((item) => item !== normalized) : [...selected, normalized];
}

export function composeQuestionAnswer(selected: string[], customAnswer: string): string {
  return [...new Set([...selected.map((item) => item.trim()), customAnswer.trim()].filter(Boolean))].join("；");
}
